import { FC } from 'react';

import { TimerProps, timerTypes } from './config';

interface IProps {
  variant: 'red' | 'blue' | 'pause';
}

const Timer: FC<IProps & TimerProps> = ({ variant, ...props }) => timerTypes(props)[variant];

export default Timer;
